export default function ({ $config, redirect }) {
  redirect($config.mrDocsBaseUrl);
}
